import * as React from 'react';
import { SVGProps } from 'react';

const IconFileFontSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 15v-3h1.942V4h-.941a1 1 0 0 0-1 1v1H.82l.833-5h12.694l.833 5h-3.18V5a1 1 0 0 0-1-1h-.941v8H12v3H4ZM9.06 3H11a2 2 0 0 1 2 2h1l-.5-3h-11L2 5h1a2 2 0 0 1 2-2h1.942v10H5.001v1h6v-1H9.06V3Z"
    />
  </svg>
);
export default IconFileFontSizeS;
